// Resolves a user's picture value to a displayable URL.
// Google avatars are absolute URLs; uploaded avatars are stored as "/api/files/{id}".
const API = process.env.REACT_APP_BACKEND_URL;

export function avatarUrl(picture) {
  if (!picture) return "";
  if (/^https?:\/\//i.test(picture) || picture.startsWith("data:")) return picture;
  return `${API}${picture}`;
}
